<mat-form-field appearance="fill" *ngIf="control">
    <mat-label
        >{{ placeholder }}
        <ng-container *ngIf="required"> *</ng-container>
    </mat-label>
    <textarea
        matInput
        #value
        [id]="id"
        [formControl]="control"
        [type]="type"
        [autocomplete]="autocomplete"
        [maxLength]="maxLength"
    ></textarea>
    <mat-hint *ngIf="maxLength">
        {{ value.value.length }} / {{ maxLength }}
    </mat-hint>
    <mat-error *ngIf="control.hasError('required')">
        {{ "ERRORS.FIELD_IS_REQUIRED" | translate }}
    </mat-error>
    <mat-error>
        <ng-content></ng-content>
    </mat-error>
</mat-form-field>
